export default __webpack_public_path__ + "static/media/valjak.e0d80cd3.jpg";